




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import FormErrorsMixin from "@/mixins/FormErrors";
import BaseMixin from "@/mixins/BaseMixin";
import { AxiosResponse } from "axios";

import Multiselect from "vue-multiselect";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

import vMultiselectListbox from "vue-multiselect-listbox";
import "vue-multiselect-listbox/dist/vue-multi-select-listbox.css";

import NavigationTabs from "@/components/Customers/Customer/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import SuccessButton from "@/components/Common/Buttons/SuccessButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import WarningButton from "@/components/Common/Buttons/WarningButton.vue";
import CustomerActionsMobile from "@/components/Customers/Customer/CustomerActionsMobile.vue";
import CustomerActionsDesktop from "@/components/Customers/Customer/CustomerActionsDesktop.vue";
import MembershipLogo from "@/components/Customers/Customer/MembershipLogo.vue";
import Error404 from "@/components/Common/Error404.vue";
import {
  ICountry,
  ICountryState,
  ICustomer,
  ICustomerGroup,
  IOrganization
} from "@/interface";

interface IPaymentMethodOption {
  id: number;
  name: string;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    MembershipLogo,
    ViewLoader,
    AlertBox,
    NavigationTabs,
    TextInput,
    InfoButton,
    SuccessButton,
    DangerButton,
    WarningButton,
    CustomerActionsMobile,
    CustomerActionsDesktop,
    Multiselect,
    DatePicker,
    VSwatches,
    vMultiselectListbox,
    Error404
  }
})
export default class CustomerData extends Mixins(FormErrorsMixin, BaseMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "first_name",
    "last_name",
    "gender",
    "title",
    "email",
    "birthdate",
    "color_code",
    "note",
    "position",
    "number",
    "phone_number.prefix",
    "phone_number.number",
    "address.country_id",
    "address.state_id",
    "address.city",
    "address.post_code",
    "address.street_name",
    "address.street_number",
    "address.additional_info"
  ];
  private countries: Array<ICountry> = [];
  private noDataExist = false;
  private membershipStatus: string | null = null;
  private customerBalance = 0;
  private customerDeleted = false;
  private customerLocked = false;
  private customerUnconfirmed = false;
  private customerInterested = false;
  private exceedanceWarning = false;
  private originalFirstName: string | null = null;
  private originalLastName: string | null = null;
  private selectedCountry: ICountry = {
    states: null
  };
  private addressCheckActive = false;
  private addressVerified = false;
  private isPortalUser = false;
  private dateFormat = "DD.MM.YYYY";
  private selectedCustomer: ICustomer = {
    first_name: null,
    last_name: null,
    gender: null,
    title: null,
    email: null,
    birthdate: null,
    color_code: null,
    note: null,
    position: null,
    number: null,
    phone_number: {
      prefix: null,
      number: null
    },
    address: {
      country_id: null,
      state_id: null,
      city: null,
      post_code: null,
      street_name: null,
      street_number: null,
      additional_info: null
    }
  };
  private selectedCustomerId: string | null = null;
  private paymentMethodValue: Array<IPaymentMethodOption> = [
    //
  ];
  private paymentMethodOptions: Array<IPaymentMethodOption> = [
    { name: "Rechnung", id: 1 },
    { name: "Bar vor Ort", id: 2 },
    { name: "Bankomat vor Ort", id: 3 },
    { name: "Kreditkarte", id: 4 },
    { name: "Paypal", id: 5 }
  ];
  // groups data
  private updatingGroupCustomers = false;
  private allGroups: Array<ICustomerGroup> = [];
  private availableGroups: Array<ICustomerGroup> = [];
  private originalSelectedGroups: Array<ICustomerGroup> = [];
  private selectedGroups: Array<ICustomerGroup> = [];
  // organizations data
  private updatingOrganizationCustomers = false;
  private allOrganizations: Array<IOrganization> = [];
  private availableOrganizations: Array<IOrganization> = [];
  private originalSelectedOrganizations: Array<IOrganization> = [];
  private selectedOrganizations: Array<IOrganization> = [];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.getGroups();
      vm.getOrganizations();
      vm.getCountries();
      vm.selectedCustomerId = vm.$route.params.customer_id;
      if (
        typeof vm.selectedCustomerId !== "undefined" &&
        vm.selectedCustomerId !== null
      ) {
        if (vm.$route.query.customer_created) {
          swal("Success!", "The customer was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getCustomer(() => {
          //
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any) {
    this.getGroups();
    this.getOrganizations();
    this.getCountries();
    if (
      typeof this.selectedCustomerId !== "undefined" &&
      this.selectedCustomerId !== null
    ) {
      this.getCustomer(() => {
        //
      });
    }
    next();
  }

  private addPaymentMethod(paymentMethod: IPaymentMethodOption) {
    this.paymentMethodValue.push(paymentMethod);
  }

  private restoreDefaultPaymentMethods(): void {
    this.paymentMethodValue = [];
  }

  private parseBirthdate(val?: Date): void {
    if (
      this.selectedCustomer.birthdate != null &&
      Object.prototype.toString.call(this.selectedCustomer.birthdate) ===
        "[object Date]"
    ) {
      let val = this.selectedCustomer.birthdate;
      this.selectedCustomer.birthdate = new Date(
        val.getFullYear() +
          "-" +
          (val.getMonth() + 1 > 9 ? "" : "0") +
          (val.getMonth() + 1) +
          "-" +
          (val.getDate() > 9 ? "" : "0") +
          val.getDate()
      );
    } else if (this.selectedCustomer.birthdate != null && val != null) {
      let parts = this.selectedCustomer.birthdate.toLocaleString().split("-");
      this.selectedCustomer.birthdate = new Date(
        parseInt(parts[0], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[2])
      );
    } else if (this.selectedCustomer.birthdate != null && val == null) {
      let parts = this.selectedCustomer.birthdate.toLocaleString().split(".");
      this.selectedCustomer.birthdate = new Date(
        parts[2] + "-" + parts[1] + "-" + parts[0]
      );
    }
  }

  private changeGroups(): void {
    this.updateCustomerGroups();
  }

  private changeOrganizations(): void {
    this.updateCustomerOrganizations();
  }

  private createOrUpdateCustomer(): void {
    if (this.selectedCustomerId == null) {
      this.createCustomer();
    } else {
      this.updateCustomer();
    }
  }

  private createCustomer(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint = this.$partnerEndpoint("customers");

    this.parseBirthdate();

    Api()
      .post(endpoint, this.selectedCustomer)
      .then((response: AxiosResponse) => {
        this.selectedCustomerId = response.data.data.id;
        this.$router.push({
          name: "CustomerData",
          params: { customer_id: `${this.selectedCustomerId}` },
          query: { customer_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#customer-first-name", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getCustomer(successCallback?: any): Promise<any> {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId
    );

    return Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedCustomer = response.data.data;
        this.parseBirthdate(response.data.data.birthdate);
        if (this.selectedCustomer.first_name !== undefined) {
          this.originalFirstName = this.selectedCustomer.first_name;
        }
        if (this.selectedCustomer.last_name !== undefined) {
          this.originalLastName = this.selectedCustomer.last_name;
        }
        if (
          this.selectedCustomer.address &&
          this.selectedCustomer.address.country_id != null
        ) {
          this.countryShouldBeSelected({
            id: this.selectedCustomer.address.country_id
          });
          this.setSelectedCountry(this.selectedCustomer.address.country_id);
          if (this.selectedCustomer.address.state_id != null) {
            this.stateShouldBeSelected({
              id: this.selectedCustomer.address.state_id
            });
          }
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
        this.getCustomerGroups();
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateCustomer(): void {
    if (this.loading || this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId
    );

    let originalBirthdate = this.selectedCustomer.birthdate;
    this.parseBirthdate();

    Api()
      .put(endpoint, this.selectedCustomer)
      .then((response: AxiosResponse) => {
        this.parseBirthdate(response.data.data.birthdate);
        this.getCustomer(() => {
          //
        });

        swal({
          title: "Success!",
          text: "The customer was updated.",
          icon: "success"
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.selectedCustomer.birthdate = originalBirthdate;
      })
      .finally(() => {
        this.updating = false;
        this.$scrollTo("#customer-first-name", 500);
      });
  }

  private getCountries(successCallback?: any): void {
    Api()
      .get("api/internal/v1/countries")
      .then((response: AxiosResponse) => {
        this.countries = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private updateCustomerGroups(): void {
    if (this.originalSelectedGroups.length < this.selectedGroups.length) {
      for (let i = 0; i < this.selectedGroups.length; i++) {
        if (!this.originalSelectedGroups.includes(this.selectedGroups[i])) {
          this.addCustomerToGroup(this.selectedGroups[i].id);
        }
      }
    } else if (
      this.originalSelectedGroups.length > this.selectedGroups.length
    ) {
      for (let i = 0; i < this.originalSelectedGroups.length; i++) {
        if (!this.selectedGroups.includes(this.originalSelectedGroups[i])) {
          this.removeCustomerFromGroup(this.originalSelectedGroups[i].id);
          this.moveToAvailableGroups(this.originalSelectedGroups[i]);
        }
      }
    }

    this.originalSelectedGroups = this.selectedGroups;
  }

  private addCustomerToGroup(selectedGroupId?: number) {
    if (this.updatingGroupCustomers) {
      return;
    }

    this.resetErrors();
    this.updatingGroupCustomers = true;
    const endpoint: string = this.$partnerEndpoint(
      "groups/" + selectedGroupId + "/customers"
    );

    Api()
      .post(endpoint, { customer_id: this.selectedCustomerId })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updatingGroupCustomers = false;
      });
  }

  private removeCustomerFromGroup(selectedGroupId?: number) {
    if (this.updatingGroupCustomers) {
      return;
    }

    this.resetErrors();
    this.updatingGroupCustomers = true;
    const endpoint: string = this.$partnerEndpoint(
      "groups/" + selectedGroupId + "/customers/" + this.selectedCustomerId
    );

    Api()
      .delete(endpoint)
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updatingGroupCustomers = false;
      });
  }

  private getGroups(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("groups");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.allGroups = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      });
  }

  private getCustomerGroups(successCallback?: any): void {
    this.resetErrors();
    let customerGroups = [];
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId + "/groups"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        customerGroups = response.data.data;
        for (let i = 0; i < this.allGroups.length; i++) {
          let selected = false;
          for (let j = 0; j < customerGroups.length; j++) {
            if (this.allGroups[i].id == customerGroups[j].id) {
              selected = true;
              break;
            }
          }
          if (selected) {
            this.moveToSelectedGroups(this.allGroups[i]);
          } else {
            this.moveToAvailableGroups(this.allGroups[i]);
          }
        }

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error.response);
      })
      .finally(() => {
        this.getCustomerOrganizations();
      });
  }

  private moveToSelectedGroups(customerGroup: ICustomerGroup): void {
    if (!this.selectedGroups.includes(customerGroup)) {
      this.selectedGroups.push(customerGroup);
    }
    this.originalSelectedGroups = this.selectedGroups;
  }

  private moveToAvailableGroups(customerGroup: ICustomerGroup): void {
    if (!this.availableGroups.includes(customerGroup)) {
      this.availableGroups.push(customerGroup);
    }
  }

  private updateCustomerOrganizations() {
    if (
      this.originalSelectedOrganizations.length <
      this.selectedOrganizations.length
    ) {
      for (let i = 0; i < this.selectedOrganizations.length; i++) {
        if (
          !this.originalSelectedOrganizations.includes(
            this.selectedOrganizations[i]
          )
        ) {
          this.addCustomerToOrganization(this.selectedOrganizations[i].id);
        }
      }
    } else if (
      this.originalSelectedOrganizations.length >
      this.selectedOrganizations.length
    ) {
      for (let i = 0; i < this.originalSelectedOrganizations.length; i++) {
        if (
          !this.selectedOrganizations.includes(
            this.originalSelectedOrganizations[i]
          )
        ) {
          this.removeCustomerFromOrganization(
            this.originalSelectedOrganizations[i].id
          );
          this.moveToAvailableOrganizations(
            this.originalSelectedOrganizations[i]
          );
        }
      }
    }

    this.originalSelectedOrganizations = this.selectedOrganizations;
  }

  private addCustomerToOrganization(selectedOrganizationId?: number) {
    if (this.updatingOrganizationCustomers) {
      return;
    }

    this.resetErrors();
    this.updatingOrganizationCustomers = true;
    const endpoint: string = this.$partnerEndpoint(
      "organizations/" + selectedOrganizationId + "/customers"
    );

    Api()
      .post(endpoint, { customer_id: this.selectedCustomerId })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updatingOrganizationCustomers = false;
      });
  }

  private removeCustomerFromOrganization(
    selectedOrganizationId?: number
  ): void {
    if (this.updatingOrganizationCustomers) {
      return;
    }

    this.resetErrors();
    this.updatingOrganizationCustomers = true;
    const endpoint: string = this.$partnerEndpoint(
      "organizations/" +
        selectedOrganizationId +
        "/customers/" +
        this.selectedCustomerId
    );

    Api()
      .delete(endpoint)
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updatingOrganizationCustomers = false;
      });
  }

  private getOrganizations(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("organizations");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.allOrganizations = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      });
  }

  private getCustomerOrganizations(successCallback?: any): void {
    let customerOrganizations = [];
    const endpoint: string = this.$partnerEndpoint(
      "customers/" + this.selectedCustomerId + "/organizations"
    );
    this.resetErrors();

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        customerOrganizations = response.data.data;
        for (let i = 0; i < this.allOrganizations.length; i++) {
          let selected = false;
          for (let j = 0; j < customerOrganizations.length; j++) {
            if (this.allOrganizations[i].id == customerOrganizations[j].id) {
              selected = true;
              break;
            }
          }
          if (selected) {
            this.moveToSelectedOrganizations(this.allOrganizations[i]);
          } else {
            this.moveToAvailableOrganizations(this.allOrganizations[i]);
          }
        }

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private moveToSelectedOrganizations(
    customerOrganization: IOrganization
  ): void {
    if (!this.selectedOrganizations.includes(customerOrganization)) {
      this.selectedOrganizations.push(customerOrganization);
    }
    this.originalSelectedOrganizations = this.selectedOrganizations;
  }

  private moveToAvailableOrganizations(
    customerOrganization: IOrganization
  ): void {
    if (!this.availableOrganizations.includes(customerOrganization)) {
      this.availableOrganizations.push(customerOrganization);
    }
  }

  private countryShouldBeSelected(country: ICountry): boolean {
    return (
      this.selectedCustomer.address !== undefined &&
      this.selectedCustomer.address.country_id == country.id
    );
  }

  private stateShouldBeSelected(state: ICountryState): boolean {
    return (
      this.selectedCustomer.address !== undefined &&
      this.selectedCustomer.address.state_id == state.id
    );
  }

  private setSelectedCountry(countryId: number): void {
    for (let i = 0; i < this.countries.length; i++) {
      if (countryId == this.countries[i].id) {
        this.selectedCountry = this.countries[i];
      }
    }
  }

  private onChangeSelectedCountry(event: any) {
    for (let i = 0; i < this.countries.length; i++) {
      if (event.target.value == this.countries[i].id) {
        this.selectedCountry = this.countries[i];
      }
    }
  }
}
